import { IS_DEVELOPMENT } from './constants';

/* eslint-disable no-console */
export function Log(vue, methodName) {
  if (IS_DEVELOPMENT) {
    // comprobar si existe vue.$options.name
    if (vue.$options !== undefined && vue.$options.name !== undefined) {
      console.log(`${vue.$options.name}-->${methodName.replace('bound ', '')}`);
    } else if (vue.name !== undefined) {
      console.log(`${vue.name}-->${methodName}`);
    } else {
      console.log(methodName.replace('bound ', ''));
    }
  }
}

export function LogDetails(vue, methodName) {
  if (IS_DEVELOPMENT) {
    console.log(`${vue.$options.name}-->${methodName.replace('bound ', '')}`);
  }
}

export function LogError(vue, methodName, errorText) {
  if (IS_DEVELOPMENT) {
    if (vue.$options !== undefined && vue.$options.name !== undefined) {
      console.error(`${vue.$options.name}-->${methodName.replace('bound ', '')}-->${errorText}`);
    } else if (vue.name !== undefined) {
      console.error(`${vue.name}-->${methodName}-->${errorText}`);
    } else {
      console.error(methodName.replace('bound ', ''), errorText);
    }
  }
}
